import React, {
    useState,
  } from "react";
  
  import {
    USER_ROLES,
  } from "../../../constants/admin/user/userConstants";
  
  import {
    validateUserForm,
  } from "../../../utils/admin/userValidation";
  
  const UserForm = ({
    formData,
    editingUser,
    handleChange,
    handleSubmit,
    isSubmitting = false,
  }) => {
    const [errors, setErrors] =
      useState({});
  
    const onSubmit = async (e) => {
      e.preventDefault();
  
      const validationErrors =
        validateUserForm(
          formData,
          editingUser
        );
  
      setErrors(validationErrors);
  
      if (
        Object.keys(validationErrors)
          .length > 0
      ) {
        return;
      }
  
      await handleSubmit();
    };
  
    return (
      <form
        onSubmit={onSubmit}
        className="space-y-4 bg-gray-100 dark:bg-gray-800 p-4 rounded"
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Name */}
          <div>
            <input
              type="text"
              name="name"
              placeholder="Tên"
              value={formData.name}
              onChange={handleChange}
              className="w-full p-2 border rounded dark:bg-gray-700 dark:text-white"
            />
  
            {errors.name && (
              <p className="text-red-500 text-sm mt-1">
                {errors.name}
              </p>
            )}
          </div>
  
          {/* Email */}
          <div>
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              disabled={!!editingUser}
              className="w-full p-2 border rounded dark:bg-gray-700 dark:text-white disabled:bg-gray-200"
            />
  
            {errors.email && (
              <p className="text-red-500 text-sm mt-1">
                {errors.email}
              </p>
            )}
          </div>
  
          {/* Password */}
          <div>
            <input
              type="password"
              name="password"
              placeholder={
                editingUser
                  ? "Để trống nếu không đổi mật khẩu"
                  : "Mật khẩu"
              }
              value={formData.password}
              onChange={handleChange}
              className="w-full p-2 border rounded dark:bg-gray-700 dark:text-white"
            />
  
            {errors.password && (
              <p className="text-red-500 text-sm mt-1">
                {errors.password}
              </p>
            )}
          </div>
  
          {/* Phone */}
          <div>
            <input
              type="text"
              name="phone"
              placeholder="Số điện thoại"
              value={formData.phone}
              onChange={handleChange}
              className="w-full p-2 border rounded dark:bg-gray-700 dark:text-white"
            />
  
            {errors.phone && (
              <p className="text-red-500 text-sm mt-1">
                {errors.phone}
              </p>
            )}
          </div>
  
          {/* Role */}
          <div>
            <select
              name="role"
              value={formData.role}
              onChange={handleChange}
              className="w-full p-2 border rounded dark:bg-gray-700 dark:text-white"
            >
              {USER_ROLES.map(
                (role) => (
                  <option
                    key={role.value}
                    value={role.value}
                  >
                    {role.label}
                  </option>
                )
              )}
            </select>
  
            {errors.role && (
              <p className="text-red-500 text-sm mt-1">
                {errors.role}
              </p>
            )}
          </div>
        </div>
  
        <button
          type="submit"
          disabled={isSubmitting}
          className={`px-4 py-2 rounded text-white ${
            isSubmitting
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-green-600 hover:bg-green-700"
          }`}
        >
          {isSubmitting
            ? editingUser
              ? "Đang cập nhật..."
              : "Đang tạo..."
            : editingUser
            ? "Cập nhật"
            : "Tạo mới"}
        </button>
      </form>
    );
  };
  
  export default UserForm;